/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { CommandResource } from '@alfa-client/command-shared';
import { HistorieService } from '@alfa-client/historie-shared';
import { HistorieItemRowComponent } from '@alfa-client/historie-shared-ui';
import { UserProfileResource } from '@alfa-client/user-profile-shared';
import { CommonModule } from '@angular/common';
import { Component, inject, input, OnInit } from '@angular/core';
import { StateResource } from '@common/tech-shared';
import { Observable } from 'rxjs';
import { HistorieItemAssignUserComponent } from './historie-item-assign-user/historie-item-assign-user.component';

@Component({
  selector: 'alfa-historie-item-assign-user-container',
  templateUrl: './historie-item-assign-user-container.component.html',
  imports: [HistorieItemRowComponent, CommonModule, HistorieItemAssignUserComponent],
})
export class HistorieItemAssignUserContainerComponent implements OnInit {
  readonly command = input.required<CommandResource>();

  private readonly service = inject(HistorieService);

  public userProfileStateResource$: Observable<StateResource<UserProfileResource>>;

  ngOnInit(): void {
    this.userProfileStateResource$ = this.service.getAssignedTo(this.command());
  }
}
